// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productSelectorStyles } from "@ces/Overrides/Components/ProductSelector";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color, xScreen } from "@ces/XDL/Utilities";
import { css } from "styled-components";

productSelectorStyles.clearIcon = {
    size: 18,
    color: "common.ui7",
    css: css`
        position: absolute;
        right: 35px;
        top: calc(100% - 35px);
        cursor: pointer;
        &:hover,
        &:focus {
            &,
            svg {
                color: ${color("common.ui8")};
            }
        }
    `,
};

productSelectorStyles.buttonGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        &&& {
            justify-content: flex-end;
            margin-left: auto;
        }
    `,
};

productSelectorStyles.selectButton = {
    css: css`
        margin-top: 21px;
        margin-bottom: 15px;
        ${xScreen("lte", "sm")} {
            margin-top: 30px;
            margin-bottom: 0;
            width: 100%;
        }
    `,
};

productSelectorStyles.productImage = {
    width: "50px",
    css: css`
        flex-shrink: 0;
        img {
            height: 100%;
            object-fit: contain;
        }
    `,
};

productSelectorStyles.qty = {
    qtyLabel: {
        css: css`
            display: block;
            font-weight: ${fontConfig.weight.bold};
            ${xScreen("lte", "lg")} {
                margin: 0;
            }
        `,
    },
    wrapper: {
        css: css`
            margin-top: 8px;
            height: 36px;
        `,
    },
};

productSelectorStyles.unitOfMeasureSelect = {
    labelProps: {
        css: css`
            &&& {
                line-height: ${fontConfig.lineHeight.xSmall};
            }
        `,
    },
};
